import React, { useState, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CancelIcon from "@mui/icons-material/Cancel";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "#FFFFFF",
  boxShadow: 24,
  borderRadius: "16px",
  p: 4,
};

export default function DeleteAccountModal({ open, handleClose }) {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (open) {
      setStep(1);
      setEmail("");
      setPassword("");
      setShowPassword(false);
    }
  }, [open]);

  const handleContinue = () => {
    if (email && password) {
      setStep(2);
    }
  };

  const handleDelete = () => {
    // the endpoint for deleting account
    handleClose();
  };

  return (
    <Modal
      aria-labelledby="delete-account-modal"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          {step === 1 && (
            <div>
              <div className="flex justify-between items-center mb-2">
                <h2 className="text-[20px] font-semibold text-[#1C1B1F]">
                  Enter account details
                </h2>
                <CancelIcon
                  onClick={handleClose}
                  className="text-[#1C1B1F] cursor-pointer"
                />
              </div>
              <p className="text-[#79747E] text-[14px] mb-6 leading-relaxed">
                Enter the details below to confirm you are the account owner
              </p>

              <div className="mb-4">
                <label className="block text-[#1C1B1F] font-medium text-[14px] mb-2">
                  Email address
                </label>
                <div className="bg-[#F4F4F4] rounded-[8px] flex items-center px-4 py-3">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Placeholder text"
                    className="bg-transparent border-none outline-none w-full text-[14px] text-[#1C1B1F]"
                  />
                </div>
              </div>

              <div className="mb-8">
                <label className="block text-[#1C1B1F] font-medium text-[14px] mb-2">
                  Enter your password
                </label>
                <div className="bg-[#F4F4F4] rounded-[8px] flex items-center px-4 py-3">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Placeholder text"
                    className="bg-transparent border-none outline-none w-full text-[14px] text-[#1C1B1F]"
                  />
                  {showPassword ? (
                    <VisibilityOffOutlinedIcon
                      onClick={() => setShowPassword(false)}
                      className="text-[#79747E] cursor-pointer"
                      sx={{ fontSize: 20 }}
                    />
                  ) : (
                    <VisibilityOutlinedIcon
                      onClick={() => setShowPassword(true)}
                      className="text-[#79747E] cursor-pointer"
                      sx={{ fontSize: 20 }}
                    />
                  )}
                </div>
              </div>

              <button
                onClick={handleContinue}
                disabled={!email || !password}
                className={`w-full py-3 rounded-[8px] text-white font-medium text-[16px] transition-colors ${
                  email && password
                    ? "bg-[#00B172] hover:bg-[#009b63]"
                    : "bg-[#a3e4cb] cursor-not-allowed"
                }`}
              >
                Continue
              </button>
            </div>
          )}

          {step === 2 && (
            <div>
              <div className="flex justify-between items-center mb-2">
                <h2 className="text-[20px] font-semibold text-[#1C1B1F]">
                  Delete account
                </h2>
                <CancelIcon
                  onClick={handleClose}
                  className="text-[#1C1B1F] cursor-pointer"
                />
              </div>
              <p className="text-[#79747E] text-[14px] mb-8 leading-relaxed">
                Are you sure you want to delete your Zouse account?
              </p>

              <div className="flex justify-end gap-4 mt-4">
                <button
                  onClick={handleClose}
                  className="bg-[#F9F9F9] text-[#1C1B1F] px-6 py-2.5 rounded-[8px] text-[14px] font-bold hover:bg-[#E6E6E6] transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleDelete}
                  className="bg-[#FF5959] text-white px-6 py-2.5 rounded-[8px] text-[14px] font-bold hover:bg-[#e04e4e] transition-colors"
                >
                  Delete account
                </button>
              </div>
            </div>
          )}
        </Box>
      </Fade>
    </Modal>
  );
}
